/**
 * Static utility class for date range calculations
 */
export class DateRangeCalculator {
  private static readonly MS_PER_DAY = 24 * 60 * 60 * 1000;

  /**
   * Calculates a date range from now going back the specified number of days
   * @param daysBack Number of days to go back from now
   * @returns Object with fromDate and toDate as ISO strings
   */
  static getDefaultDateRange(daysBack: number): { fromDate: string; toDate: string } {
    const now = new Date();
    const fromDate = new Date(Date.now() - daysBack * this.MS_PER_DAY);

    return {
      fromDate: fromDate.toISOString(),
      toDate: now.toISOString(),
    };
  }

  /**
   * Creates a date range for the last 90 days (default for usage statistics)
   */
  static getLast90Days(): { fromDate: string; toDate: string } {
    return this.getDefaultDateRange(90);
  }
}
